goog.provide("shadow.js.shim.module$cron_parser");
goog.provide("module$shadow_js_shim_module$cron_parser");
shadow.js.shim.module$cron_parser = shadow.js.nativeProvides["cron-parser"] = shadow$bridge("cron-parser");
module$shadow_js_shim_module$cron_parser.default = shadow.js.shim.module$cron_parser;
